import React, { useEffect, useState } from "react";
import { useAuthUserToken } from "./../../hooks/useAuthUserToken";
import toast from "react-hot-toast";
import { getClientURL } from "../../helperFunctions/apiFunction";
const TrainingPdfView = ({ setPdfView, pdfData, trainingTitle }) => {
  const [isLoadingFile, setIsLoadingFile] = useState(true);
  const { completeAuthData: authData, refreshToken } = useAuthUserToken();
  const [fileUrl, setFileUrl] = useState("");
  useEffect(() => {
    getClientURL(refreshToken, pdfData?.trainingFile)
      .then((response) => {
        setFileUrl(response?.fileUrl);
      })
      .catch((error) => {
        toast.error(error?.message, {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        setIsLoadingFile(false);
      });
  }, []);
  return (
    <div className="flex justify-between items-stretch p-4">
      {fileUrl ? (
        <>
          {isLoadingFile ? (
            <>
              <div className="align-items-center flex justify-center w-100">
                <div class="w-16 h-16 border-8 border-dashed rounded-full animate-spin border-blue-600"></div>
              </div>
            </>
          ) : (
            <>
              <div className="w-full min-h-screen flex flex-col">
                <iframe
                  src={fileUrl}
                  title="PDF Viewer"
                  className="flex-grow"
                  width="100%"
                  height="100%"
                />
              </div>
            </>
          )}
        </>
      ) : (
        <div className="flex flex-col items-center w-full">
          <img
            quality={100}
            src="/assets/images/9276430.jpg"
            className="w-[350px] mix-blend-darken"
            alt="no-data-found"
          />
          <p className="text-[20px] font-medium">No Document Found!</p>
        </div>
      )}
    </div>
  );
};

export default TrainingPdfView;
